<template>
  <div>
    <Modal
      ref="modal"
      :title="isPreview ? 'Preview & Send E-signature' : 'Select E-signature Template'"
      :action="action"
      actionColor="indigo"
      @closeModal="handleCancel"
      @handleAction="handleSend"
    >
      <RadioSelect class="mt-4" v-if="loaded && !isPreview" :options="templatesForSelect" v-model="selectedTemplate" />
      <div v-if="submission">
        <docuseal-form id="docusealForm" :data-src="submission.embed_src" data-preview="true" data-with-title="false">
        </docuseal-form>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from '../shared/Modal.vue';
import RadioSelect from '../shared/RadioSelect.vue';

export default {
  props: ['record'],
  components: {
    Modal,
    RadioSelect,
  },
  data() {
    return {
      selectedTemplate: '',
      templates: [],
      templatesForSelect: [],
      companySigner: this.$store.state.general.currentUserAccountDetails.username,
      submission: null,
      isPreview: false,
      action: 'Preview',
      loaded: false,
    };
  },
  mounted() {
    this.getTemplates();
  },
  methods: {
    handleSend() {
      const self = this;
      self.$store.commit('general/showLocalLoadingSpinner');
      self.isPreview = !self.isPreview;
      fetch(`/api/esignature_templates/send_for_signature/`, {
        method: 'POST',
        body: JSON.stringify({
          id: self.record.id,
          is_preview: self.isPreview,
          template_id: self.templatesForSelect.find(temp => temp.label === self.selectedTemplate)?.id,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          self.submission = data.record;
          self.$store.commit('general/hideLocalLoadingSpinner');
          if (!self.isPreview) {
            if (data.status != 'error') {
              this.$emit('handleSubmit');
              self.$store.commit('general/showAlert', {
                alertType: 'success',
                alertTitle: 'Esignature successfully sent!',
                alertDescription: 'Your esignature template has been successfully send for signature.',
              });
            } else {
              self.$store.commit('general/showAlert', {
                alertType: 'error',
                alertTitle: 'Esignature send error',
                alertDescription: data.message,
              });
            }
          } else {
            self.action = 'Send';
            if (data.status == 'error') {
              self.$store.commit('general/showAlert', {
                alertType: 'error',
                alertTitle: 'Esignature send error',
                alertDescription: data.message,
              });
            }
          }
        });
    },
    handleCancel() {
      this.$emit('handleCancel');
    },
    getTemplates() {
      const self = this;
      fetch(`/api/esignature_templates/`)
        .then(response => {
          return response.json();
        })
        .then(data => {
          for (let template of data.records) {
            self.templates.push({
              id: template.id,
              name: template.name,
            });
            self.templatesForSelect.push({
              id: template.id,
              label: template.name,
              description: ''
            });
          }
          self.selectedTemplate = self.templatesForSelect[0].label;
          self.loaded = true;
        });
    },
  },
};
</script>
